import { render, staticRenderFns } from "./SoldOut.vue?vue&type=template&id=54940e72&scoped=true&"
import script from "./SoldOut.vue?vue&type=script&lang=js&"
export * from "./SoldOut.vue?vue&type=script&lang=js&"
import style0 from "./SoldOut.vue?vue&type=style&index=0&id=54940e72&prod&lang=scss&scoped=true&"
import style1 from "./SoldOut.vue?vue&type=style&index=1&id=54940e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54940e72",
  null
  
)

export default component.exports